import styled from 'styled-components';

export const RoundAvatarContainer = styled.img`
  border-radius: 50%;
  height: ${props => props.squareSize}rem;
  margin: auto 1rem auto 0;
  object-fit: cover;
  width: ${props => props.squareSize}rem;
`;
